export enum UserRoles {
    AieAdmin = 'org-admin',
    AieOrgReader = 'aie:org-reader',
    AieOrgWriter = 'aie:org-writer',
}

export enum UserOtherMetaRoles {
    Analyst = 'analyst',
}
